<app-header-one [class]="'header-gym'"></app-header-one>
<!-- <app-separator  [size]="'lg'"></app-separator> -->


<section class="section-b-space checkpay-page pt-0 mb-5">
  <div class="container">
    <div class="row">
      <div class="col-xl-3 col-lg-3 col-md-3">
          <h2 class="my-5 d-none d-md-block">Il tuo ordine</h2>
          <div class="mt-4 d-block d-md-none"><app-navigation-bar [page]="'Checkout'"></app-navigation-bar></div>
      </div>
      <div class="col-xl-9 col-lg-9 col-md-9 mt-5">
        <div class="row mt-5">
          <div class="col-xl-6 col-12">
              <div class="checkout-page">
                <div class="checkout-title m-0">
                  <h3>Pagamento</h3>
                </div>
                <div class="checkout-form py-3" *ngIf="cartData">
                  <ng-container *ngFor="let payment of payments">
                    <div *ngIf="payment.id==payType.MONEY && !hideCash && cartData.order.credit == 0"
                      class="media d-flex justify-content-between align-items-center border-product eit-bt-border" (click)="goToPay(payment)">


                      <div class="media-body align-self-center">

                        <h6 class="product-title text-start mt-2">Contanti</h6>

                        <!--p>Paga in contanti al fattorino</p-->

                      </div>
                      <!-- <img class="img-fluid w-auto" src="assets/images/Icone/contanti.png" alt="Contanti"
                        title="Paga in contanti alla consegna del tuo ordine."> -->
                    </div>

                    <div *ngIf="payment.id==payType.PAYPAL" class="media border-product eit-bt-border d-flex justify-content-between align-items-center"
                      (click)="goToPay(payment)">
                      <div class="media-body align-self-center">

                        <h6 class="product-title text-start mt-2">Paypal</h6>

                        <!--p>Paga con il tuo conto Paypal o carta di credito</p-->

                      </div>

                      <img class="img-fluid w-auto" src="assets/images/paypal.png" alt="PayPal"
                        title="Paga con il tuo conto Paypal o carta di credito">

                    </div>

                    <div *ngIf="payment.id==payType.SATISPAY" class="media border-product eit-bt-border d-flex justify-content-between align-items-center"
                      (click)="goToPay(payment)">
                      <div class="media-body align-self-center">

                        <h6 class="product-title text-start mt-2">Satispay</h6>

                        <!--p>Paga con il tuo cellulare</p-->

                      </div>

                      <img class="img-fluid w-auto" src="assets/images/satispay.png" alt="Satispay"
                        title="Paga con il tuo cellulare">

                    </div>

                    <!--<div *ngIf="payment.id==payType.CREDIT" class="media border-product eit-bt-border d-flex justify-content-between align-items-center"  (click)="goToPay(payment)">
                          
                                    <img  class="img-fluid w-auto" [defaultImage]="'assets/images/product/placeholder.jpg'"
                                      [lazyLoad]="'https://assets.eatintime.it/imgs/eatpoints.png'" alt="">
                                    
                                    <div class="media-body align-self-center">
                            
                                      <h6 class="product-title">EatPoints/Credito</h6>
                            
                                      <p>Utilizza il credito o converti i tuoi eatpoints</p>
                                      
                                    </div>
                                    <button type="button" class="btn quantity-right-plus align-self-center btn-menu-cart" data-type="plus">
                                    Paga
                                    </button>
                                  </div>-->

                    <div *ngIf="payment.id==payType.CARD" class="media border-product eit-bt-border d-flex justify-content-between align-items-center"
                      (click)="goToPay(payment)">
                      <div class="media-body align-self-center">

                        <h6 class="product-title text-start mt-2">Carta di credito</h6>

                        <!--p>Paga con la tua carta di credito</p-->

                      </div>

                      <!-- <img class="img-fluid w-auto" src="assets/images/Icone/carta.png" alt="Carta di credito"
                        title="Paga con la tua carta di credito"> -->

                    </div>

                    <!--<div *ngIf="payment.id==payType.INLIRE" class="media border-product eit-bt-border"  (click)="goToPay(payment)">
                          
                                    <img  class="img-fluid w-auto" [defaultImage]="'assets/images/product/placeholder.jpg'"
                                      [lazyLoad]="'https://assets.eatintime.it/imgs/in-lire.png'" alt="">
                                    
                                    <div class="media-body align-self-center">
                            
                                      <h6 class="product-title">In-Lire</h6>
                            
                                      <p>Paga con il tuo credito InLire</p>
                                      
                                    </div>
                                    <button type="button" class="btn quantity-right-plus align-self-center btn-menu-cart" data-type="plus">
                                    Paga
                                    </button>
                                  </div>-->

                  </ng-container>

                </div>
              </div>
          </div>
          <div class="col-xl-6 col-12 d-none d-md-block">
              <app-cart-box [editable]="false" [loader]="false" [showCoupon]="false" [showProducts]="true" [restaurant]="restaurant">
              </app-cart-box>
          </div>
          <!--div class="col-lg-4 col-sm-12 col-xs-12 d-none d-sm-block" *ngIf="cartData.order.type_order==typeOrder.REST_ASPORTO">
              <app-carttakeaway-box [editable]="false" [loader]="false" [showCoupon]="true" [showProducts]="false">
              </app-carttakeaway-box>
          </div-->

        </div>
      </div>
    </div>
  </div>
</section>
<!-- <section class="total-section fixed-b py45 px-3 d-block d-md-none" *ngIf="cartData">
  <div class="media mx-3 d-flex justify-content-between" *ngIf="cartData.order.type_order == typeOrder.REST_DOMICILIO || cartData.order.type_order == typeOrder.REST_DOMICILIO">
    <div class="media-body align-self-top">
      <p class="product-title m-0 total-title text-start">Totale</p>
    </div>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
      {{cartData.order.euro_total.toFixed(2)}} &euro;
    </p>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
      {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
    </p>
  </div>

  <div class="media mx-3 d-flex justify-content-between" *ngIf="cartData.order.type_order == typeOrder.REST_ASPORTO">
    <div class="media-body align-self-top">
      <p class="product-title m-0 total-title text-start">Totale</p>
    </div>

    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
      {{cartData.order.euro_total.toFixed(2)}} &euro;
    </p>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
      {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
    </p>
  </div>
</section> -->
<section class="total-section py-4 px-3 d-block d-md-none" *ngIf="cartData">
  <div class="media mx-3 d-flex justify-content-between" *ngIf="cartData.order.type_order == typeOrder.REST_DOMICILIO || cartData.order.type_order == typeOrder.REST_DOMICILIO">
    <div class="media-body align-self-top">
      <p class="product-title m-0 total-title text-start">Totale</p>
    </div>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
      {{cartData.order.euro_total.toFixed(2)}} &euro;
    </p>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
      {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
    </p>
  </div>

  <div class="media mx-3 d-flex justify-content-between" *ngIf="cartData.order.type_order == typeOrder.REST_ASPORTO">
    <div class="media-body align-self-top">
      <p class="product-title m-0 total-title text-start">Totale</p>
    </div>

    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
      {{cartData.order.euro_total.toFixed(2)}} &euro;
    </p>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
      {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
    </p>
  </div>
</section>
<app-footer-two [class]="'bg-img-gym bg-size'"></app-footer-two>